var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarketLaunch = function SvgMarketLaunch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 47151"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0a48.785 48.785 0 0 0-45.563 31.313l14.25 14.25A51.5 51.5 0 0 0 45.75 34.5 48.6 48.6 0 0 0 60 0M39.375 15a5.625 5.625 0 0 1 11.25 0 5.625 5.625 0 0 1-11.25 0",
    "data-name": "Path 44517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 52.499c.188-2.25-.75-7.875 2.438-14.812A29.62 29.62 0 0 0 0 59.999a29.9 29.9 0 0 0 21.188-8.812l1.125-1.125C15.375 53.249 9.75 52.312 7.5 52.499",
    "data-name": "Path 44518"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 45.375a41 41 0 0 1 .375-8.25l-.375-.375a21.4 21.4 0 0 0-3.375 12 22.86 22.86 0 0 0 11.813-3.375L22.688 45a39.3 39.3 0 0 1-8.063.375",
    "data-name": "Path 44519"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.687 48.375 37.5 57a1.9 1.9 0 0 0 3.375-.375L48 39.75a3.66 3.66 0 0 0 .187-2.438 53.2 53.2 0 0 1-16.5 11.063",
    "data-name": "Path 44520"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.813 22.5 8.812 5.813A51.3 51.3 0 0 1 22.688 12a4.3 4.3 0 0 0-2.625.188L3.188 19.313a1.863 1.863 0 0 0-.375 3.187",
    "data-name": "Path 44521"
  }))));
};
export default SvgMarketLaunch;